export default "__VITE_ASSET__BTVvmE6o__"